import React, { Component } from 'react';
import { Button,  Grid,  } from 'semantic-ui-react'
import { alogoliaAccount, algoliaKey, firebaseAuth } from '../../../../config/constants';
import * as algoliasearch from 'algoliasearch';
import Status from '../../../../config/OrderStatusConstants.js'
import { checkAdminEmail } from '../../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';

class SingleStatusViewButtonList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            faceList: []
        }

        this.client = algoliasearch(alogoliaAccount, algoliaKey);
        this.index = this.client.initIndex('printboda_test');
    }


    componentDidMount() {
        console.log("++++++++: componentDidMount");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");
            if (user) {
                console.log("elx1 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
            

                if (user) {
                    console.log("maddx241 user is:" + user.email);

                    this.getFacets();

                    if (user.email) {
                        console.log("addx290 user.email  is:" + user.email);
                        this.setState({
                            user: user
                        })

                        //CHECK ALGOLIA FOR USER
                        checkAdminEmail(user.email, this.setAdminResult)
                    }

                } else {
                    console.log("rlx121 user NOT found");
                    this.setState({
                        authed: false,
                        // loading: false,
                        admin: false,
                        user: user,
                        uid: user.uid
                    })
                }


            } else {
                console.log("rlx121 user NOT found");

            }
        })

    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
       // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    getFacets = () => {
        this.index.searchForFacetValues({ facetName: 'status', facetQuery: '' })
            .then(content => {
                console.log("aglx13:" + JSON.stringify(content.facetHits, null, 3));
                this.setState({
                    faceList: content.facetHits
                })
            }).catch(function (err) {
                console.log(err);
                console.log(err.debugData);
            });
    }



    render() {

        const buttonList = this.state.faceList.map((facet) =>

            facet.value !== Status.delivered
                && facet.value !== Status.lost
                && facet.value !== Status.cancelled
                && facet.value !== Status.total_loss
                && facet.value !== Status.refused
                ?
                <Grid.Column>
                    <Button >
                        <a href={'https://printboda.com/dashboard/singleStatusView/' + facet.value}>
                            {facet.value} - {facet.count}
                        </a>
                    </Button>
                </Grid.Column>
                : ''

        )

        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'


        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.isAdmin
            ? <div>

<Grid stackable columns={1}>
                {buttonList}
            </Grid>
            </div>
            : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (<div>
            <h1>BUTTON LIST</h1>

            {wholeUI}

        </div>);
    }
}

export default SingleStatusViewButtonList;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/SingleStatusViewAlgolia/SingleStatusViewButtonList.js